import { FormFieldModel } from './form-field.model';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';

export class PanelFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    fields: FormFieldModel[];
    hasAutoGenAccess?: (x: any) => boolean;
    appearCondition?: (x: any) => boolean;
    paddingBottom: number = 10; // default is 10 in the constructuor

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        description: string,
        fields: FormFieldModel[],
        hasAutoGenAccess?: (x: any) => boolean,
        appearCondition?: (x: any) => boolean,
        paddingBottom?: number
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
        this.fields = fields;
        this.hasAutoGenAccess = hasAutoGenAccess;
        this.appearCondition = appearCondition;
        this.paddingBottom = paddingBottom;
    }
}
